import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import { BiPaperPlane, BiCloudDownload } from "react-icons/bi";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import axios from 'axios';
import firebase from 'firebase/compat/app';
import { FaTrash } from 'react-icons/fa';

const firebaseConfig = {
  apiKey: "AIzaSyCI59gnHA9AZAANjoy082vht3fCgatchEg",
  authDomain: "hospital-management-syst-7e35d.firebaseapp.com",
  databaseURL: "https://hospital-management-syst-7e35d-default-rtdb.firebaseio.com",
  projectId: "hospital-management-syst-7e35d",
  storageBucket: "hospital-management-syst-7e35d.firebasestorage.app",
  messagingSenderId: "59517358381",
  appId: "1:59517358381:web:96f502e3832ddf1a8fc3a4",
  measurementId: "G-EYLWMBT9SP"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const storage = firebase.storage();



async function GenerateInvoice(patientId, patientName, billTo, billToEmail, billToAddress, billToPhone, billFrom, billFromEmail, billFromAddress, billFromPhone, notes, additionalNotes, invoiceNumber, dateOfIssue, total, selectedMedicineNames, subTotal, discountAmount, taxAmount, items, color1, color2, address, socialMedia, hospital) {
  const canvas = await html2canvas(document.querySelector("#invoiceCaptureprint"));
  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'pt',
    format: [612, 792]
  });
  pdf.internal.scaleFactor = 1;
  const imgProps = pdf.getImageProperties(imgData);
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  const fileName = `${patientId}_${billFrom}.pdf`;
  pdf.save(fileName);
  const blob = pdf.output('blob');

  const storageRef = storage.ref();
  const pdfRef = storageRef.child(`createbill/${fileName}`);
  let pdfURL = '';
  let uploadSuccessful = false;

  
    try {
      await pdfRef.put(blob);
      pdfURL = await pdfRef.getDownloadURL();
      uploadSuccessful = true;
    } catch (error) {
      console.error('Error uploading PDF:', error);
    }

  const BillData = {
    hospital,
    url: uploadSuccessful ? pdfURL : 'placeholder-url-or-error',
    patientId,
    patientName,
    billTo,
    billToEmail,
    billToAddress,
    billToPhone,
    billFrom,
    billFromEmail,
    billFromAddress,
    billFromPhone,
    invoice: invoiceNumber,
    total,
    dateOfIssue,
    notes,

    selectedMedicineNames,
    subTotal: subTotal,
    taxAmount: taxAmount,
    discountAmount,
    
    additionalNotes: JSON.stringify(additionalNotes),
    items: JSON.stringify(items),
    color1,
    color2,
    address,
    socialMedia
  };

  console.log("Billdata:", BillData);

  try {
    const createResponse = await fetch('https://us-central1-hospital-management-syst-7e35d.cloudfunctions.net/api/create-billModal', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(BillData),
    });

    const createData = await createResponse.json();
    console.log("createData:", createData);
    if (!createResponse.ok) {
      throw new Error('Failed to store prescription');
    }

    console.log(createData);
  } catch (error) {
    console.error('Error storing prescription:', error);
  }
}


class InvoiceModal extends React.Component {

  // handleSendInvoice = async () => {
  //   const { info } = this.props;
  //   const canvas = await html2canvas(document.querySelector("#invoiceCapture"));
  //   const imgData = canvas.toDataURL('image/png');
  //   const pdf = new jsPDF({
  //     orientation: 'portrait',
  //     unit: 'pt',
  //     format: [612, 792]
  //   });
  //   pdf.internal.scaleFactor = 1;
  //   const imgProps = pdf.getImageProperties(imgData);
  //   const pdfWidth = pdf.internal.pageSize.getWidth();
  //   const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  //   pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //   const blob = pdf.output('blob');
  //   console.log("blob:", blob);
  //   const formData = new FormData();
  //   console.log("formData:", formData);
  //   console.log("patientId:",info.patientId);
  //   formData.append('pdf', blob, `${info.patientId}_${info.billFrom}.pdf`);
  //   formData.append('billFromEmail', info.billFromEmail);
  //   formData.append('billToEmail', info.billToEmail);

  //   try {
  //     await axios.post('http://localhost:3000/send-invoice-email', formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     });
  //     alert('Email sent successfully');
  //   } catch (error) {
  //     console.error('Error sending email:', error);
  //     alert('Failed to send email');
  //   }
  // }

  render() {
    const { showModal, closeModal, info, items, currency, total, subTotal, taxAmount, discountAmount, selectedMedicineNames = [], color1, color2, color3, color4, socialMedia, address={}, hospital } = this.props;
    console.log(subTotal);
    return (
      <div>
          <Modal show={showModal} onHide={closeModal} size="lg" centered>
          <div id="invoiceCaptureprint" className="p-4">
            <div className="d-flex flex-row justify-content-between align-items-start w-100 p-4" style={{ backgroundColor: color1 }}>
            <div>
              <h6>Address</h6>
              {address.streetName1 && <div>{address.streetName1},{address.streetName2}</div>}
              {address.area && <div>{address.area}</div>}
              {address.city && <div>{address.city}</div>}
            </div>
              <div className="w-100" style={{ marginLeft: "10px", textAlign: "center" }}>
                <h4 className="fw-bold my-2">{info.billFrom || 'John Uberbacher'}</h4>
                <h6 className="fw-bold text-secondary mb-1">
                  Invoice #: {info.invoiceNumber || ''}
                </h6>
              </div>
              <div className="text-end ms-4">
                <h6 className="fw-bold mt-1 mb-2">Amount Due:</h6>
                <h5 className="fw-bold text-secondary">{currency} {total}</h5>
              </div>
            </div>
            <div className="p-4">
              <Row className="mb-4">
                <Col md={4}>
                  <div className="fw-bold">Billed to:</div>
                  <div>{info.billTo || ''}</div>
                  <div>{info.billToAddress || ''}</div>
                  <div>{info.billToEmail || ''}</div>
                </Col>
                <Col md={4}>
                  <div className="fw-bold">Billed From:</div>
                  <div>{info.billFrom || ''}</div>
                  <div>{info.billFromAddress || ''}</div>
                  <div>{info.billFromEmail || ''}</div>
                </Col>
                <Col md={4}>
                  <div className="fw-bold mt-2">Date Of Issue:</div>
                  <div>{info.dateOfIssue || ''}</div>
                </Col>
              </Row>
              <Table className="mb-0">
                <thead>
                  <tr>
                    <th>Medicine Name</th>
                    <th>QTY</th>
                    <th className="text-end">PRICE</th>
                    <th className="text-end">AMOUNT</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, i) => (
                    <tr key={i}>
                      <td>{selectedMedicineNames[i] || item.name}</td>
                      <td style={{ width: '70px' }}>{item.quantity}</td>
                      <td className="text-end" style={{ width: '100px' }}>{currency} {item.price}</td>
                      <td className="text-end" style={{ width: '100px' }}>{currency} {(item.price * item.quantity).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Table>
                <tbody>
                  <tr className="text-end">
                    <td></td>
                    <td className="fw-bold" style={{ width: '100px' }}>SUBTOTAL</td>
                    <td className="text-end" style={{ width: '100px' }}>{currency} {info.subTotal}</td>
                  </tr>
                  {info.taxAmount !== '0.00' &&
                    <tr className="text-end">
                      <td></td>
                      <td className="fw-bold" style={{ width: '100px' }}>TAX</td>
                      <td className="text-end" style={{ width: '100px' }}>{currency} {info.taxAmount}</td>
                    </tr>
                  }
                  {info.discountAmount !== '0.00' &&
                    <tr className="text-end">
                      <td></td>
                      <td className="fw-bold" style={{ width: '100px' }}>DISCOUNT</td>
                      <td className="text-end" style={{ width: '100px' }}>{currency} {info.discountAmount}</td>
                    </tr>
                  }
                  <tr className="text-end">
                    <td></td>
                    <td className="fw-bold" style={{ width: '100px' }}>TOTAL</td>
                    <td className="text-end" style={{ width: '100px' }}>{currency} {info.total}</td>
                  </tr>
                </tbody>
              </Table>
              {info.notes &&
                <div className="bg-light py-3 px-4 rounded">
                  {info.notes}
                </div>}
                <div className="mt-4 text-center footerbill" style={{backgroundColor: color2 || "lightgrey"}}>
              {/* <p className="fw-bold">Thank you!</p>
              <p>Contact us: {this.state.billFromEmail || 'email@example.com'}</p>
              <p>{this.state.billFromAddress || '1234 Street, City, Country'}</p> */}
              <div className="social-icons mt-3 d-flex justify-content-center">
                {socialMedia?.facebook && (
                  <div className="d-flex align-items-center mx-2">
                    <i className="fab fa-facebook fa-2x"></i>
                    <span className="ms-2">{socialMedia.facebook}</span>
                  </div>
                )}
                {socialMedia?.instagram && (
                  <div className="d-flex align-items-center mx-2">
                    <i className="fab fa-instagram fa-2x"></i>
                    <span className="ms-2">{socialMedia.instagram}</span>
                  </div>
                )}
                {socialMedia?.linkedin && (
                  <div className="d-flex align-items-center mx-2">
                    <i className="fab fa-linkedin fa-2x"></i>
                    <span className="ms-2">{socialMedia.linkedin}</span>
                  </div>
                )}
                {socialMedia?.youtube && (
                  <div className="d-flex align-items-center mx-2">
                    <i className="fab fa-youtube fa-2x"></i>
                    <span className="ms-2">{socialMedia.youtube}</span>
                  </div>
                )}
              </div>



            </div>
            </div>
            <div className="pb-4 px-4">
              <Row>
                <Col md={6}>
                  {/* <Button variant="primary" className="d-flex align-items-center" onClick={this.handlePrint}><BiCloudDownload /> Download</Button> */}
                  <Button variant="primary" className="d-flex align-items-center" onClick={() => GenerateInvoice(info.patientId, info.patientName, info.billTo, info.billToEmail, info.billToAddress, info.billToPhone, info.billFrom, info.billFromEmail, info.billFromAddress, info.billFromPhone, info.notes, info.additionalNotes, info.invoiceNumber, info.dateOfIssue, info.total, selectedMedicineNames, subTotal, discountAmount, taxAmount, items, color1, color2, address, socialMedia, hospital)}><BiCloudDownload /> Download</Button>
                </Col>
              </Row>
            </div>
          </div>
        </Modal>
        <hr className="mt-4 mb-3" />
      </div>
    );
  }
}

export default InvoiceModal;
